import { useAppDispatch, useAppSelector } from 'store/hooks'
import { scrollTo } from 'helpers/animateScroll'
import { FieldError, setErrors, removeError } from 'store/order-slice'

export const useErrorMessages = () => {
    const dispatch = useAppDispatch()
    const { errors } = useAppSelector((state) => state.order)

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setErrorMessages = (error: any) => {
        if ('messages' in error) {
            const messages = error?.messages as FieldError[]

            if (messages.length === 0) return

            dispatch(setErrors(messages))

            const id = messages[0].property_path

            return scrollTo({ id, duration: 1000, margin: 100 })
        }

        console.log('API ERROR: ', error)
    }

    const getError = (field: string) =>
        errors.find((error) => error.property_path === field)?.message

    const handleRemoveError = (field: string) => {
        if (!getError(field)) return

        dispatch(removeError(field))
    }

    const clearErrorMessages = () => {
        dispatch(setErrors([]))
    }

    return {
        setErrorMessages,
        getError,
        handleRemoveError,
        clearErrorMessages,
    }
}
